export const ICON_CATEGORIES = [
    'Generic',
    'Nature',
    'Water',
    'Structure',
    'Recreation',
    'Hazard',
    'Transport',
    'Service',
    'Tools',
    'Animals',
    'Other',
];
// Curated icon → category map. Names match the Lucide registry in
// lucideIconCatalog.ts. Anything not listed here falls under "Other"
// so adding a new icon to the catalog without categorising it is safe.
const RAW_CATEGORY_MAP = {
    Generic: [
        'MapPin',
        'MapPinned',
        'MapPinHouse',
        'Pin',
        'Crosshair',
        'Target',
        'Bookmark',
        'Flag',
        'Star',
        'Heart',
        'Circle',
        'Triangle',
        'Diamond',
        'Plus',
        'Navigation',
        'Map',
    ],
    Nature: [
        'TreePine',
        'TreeDeciduous',
        'TreePalm',
        'Trees',
        'Mountain',
        'MountainSnow',
        'Flower',
        'Flower2',
        'Leaf',
        'LeafyGreen',
        'Sprout',
        'Cherry',
        'Grape',
    ],
    Water: [
        'Waves',
        'Droplet',
        'Droplets',
        'Anchor',
        'Fish',
        'FishSymbol',
        'Sailboat',
        'Ship',
        'Shell',
        'LifeBuoy',
        'FishingHook',
        'FishingRod',
    ],
    Structure: [
        'House',
        'Building',
        'Building2',
        'Tent',
        'TentTree',
        'Warehouse',
        'Factory',
        'Castle',
        'Church',
        'Hospital',
        'School',
        'Library',
        'Landmark',
        'Hotel',
        'DoorOpen',
        'DoorClosed',
        'Birdhouse',
    ],
    Recreation: [
        'Bike',
        'Footprints',
        'Binoculars',
        'Compass',
        'Caravan',
    ],
    Hazard: [
        'AlertTriangle',
        'OctagonAlert',
        'ShieldAlert',
        'Skull',
        'Construction',
        'Siren',
        'Flame',
    ],
    Transport: [
        'Car',
        'CarFront',
        'CircleParking',
        'SquareParking',
        'ParkingMeter',
        'Fuel',
        'Plane',
        'Bus',
        'Train',
        'Truck',
        'Tractor',
    ],
    Service: [
        'Coffee',
        'Utensils',
        'ShoppingCart',
        'ShoppingBag',
        'Store',
        'Stethoscope',
        'Phone',
        'Wifi',
    ],
    Tools: [
        'Wrench',
        'Hammer',
        'Shovel',
        'Axe',
        'Pickaxe',
    ],
    Animals: [
        'Cat',
        'Dog',
        'Bird',
        'Bug',
        'Squirrel',
        'Worm',
        'Rabbit',
    ],
    Other: [],
};
const categoryByIcon = (() => {
    const m = new Map();
    for (const category of ICON_CATEGORIES) {
        for (const name of RAW_CATEGORY_MAP[category]) {
            if (!m.has(name))
                m.set(name, category);
        }
    }
    return m;
})();
export const getCategoryForIcon = (iconName) => { var _a; return (_a = categoryByIcon.get(iconName)) !== null && _a !== void 0 ? _a : 'Other'; };
export const humanizeIconName = (iconName) => iconName
    // PascalCase → space-separated (e.g. "TreePine" → "Tree Pine")
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    // Allow numeric suffixes to stay glued ("Flower2" → "Flower 2")
    .replace(/([a-zA-Z])(\d)/g, '$1 $2');
